var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-container",on:{"click":function($event){_vm.$emit('click', $event)}}},[_c('Clickable',[_c('StatusIcon',{attrs:{"status":"true"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }